import { Directive } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';

/**
 * Typed ControlValueAccessor base. `V` is the form value type.
 * Inheritance-only base — a selectorless @Directive, never declared in a template.
 */
@Directive()
export abstract class CustomFormControlComponent<V = unknown> implements ControlValueAccessor {
  touched = false;

  disabled = false;

  onChange?: (val: V | null) => void;

  onTouched: () => void = () => {};

  registerOnChange(onChange: (val: V | null) => void): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: () => void): void {
    this.onTouched = onTouched;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  /** User-driven value change — marks touched and notifies the form. Never call from writeValue. */
  onChanged(obj: V | null): void {
    this.markAsTouched();
    if (this.onChange) {
      this.onChange(obj);
    }
  }

  markAsTouched(): void {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  abstract writeValue(obj: V | null): void;
}
